import './style.css'
import ReactDOM from 'react-dom/client'
import { Canvas } from '@react-three/fiber'
import Experience from './Experience.jsx'
import { KeyboardControls } from '@react-three/drei'
import Interface from './Interface.jsx'

const root = ReactDOM.createRoot(document.querySelector('#root'))

// root.render(

//     <Canvas
//         shadows
//         camera={ {
//             fov: 45,
//             near: 0.1,
//             far: 200,
//             position: [ 2, 1, -35]
//         } }
//     >
//         <Experience />
//     </Canvas>
// )

root.render(
    <KeyboardControls
        map={ [
            { name: 'forward', keys: ['ArrowUp', 'keyW', ] },
            { name: 'backward', keys: [ 'ArrowDown', 'KeyS' ] },
            { name: 'leftward', keys: [ 'ArrowLeft', 'KeyA' ] },
            { name: 'rightward', keys: [ 'ArrowRight', 'KeyD' ] },
            { name: 'jump', keys: [ 'Space' ] },
        ] }
    >
        <Canvas
            shadows
            camera={ {
                fov: 45,
                near: 0.1,
                far: 500,
                position: [ 2, 3, -35 ]
            } }
        >
            <Experience />
        </Canvas>
        <Interface />
    </KeyboardControls>
)